import { MutableRefObject, useEffect, useRef } from 'react';
import { ChatMessageResponse } from '../../services/chatbot.service';
import { DWELL_MS, shouldAsk } from './feedbackTrigger';
import { assistantStorage } from './assistantStorage';

interface Params {
  turn: { sessionId: string; message: ChatMessageResponse } | null;
  isStreaming: boolean;
  userTypingRef: MutableRefObject<boolean>;
  onTrigger: (t: { sessionId: string; messageId: string }) => void;
}

/** Espera 20 s después de una respuesta y decide si el Asistente pregunta (spec §4, paso 1). */
export function useFeedbackTrigger({ turn, isStreaming, userTypingRef, onTrigger }: Params) {
  const onTriggerRef = useRef(onTrigger);
  onTriggerRef.current = onTrigger;
  const messageId = turn?.message.id;

  useEffect(() => {
    if (!turn || isStreaming) return;
    const timer = window.setTimeout(() => {
      const ok = shouldAsk({
        messageId: turn.message.id, content: turn.message.content, sessionId: turn.sessionId,
        askedSessions: assistantStorage.getAskedSessions(), snoozedUntil: assistantStorage.getSnoozedUntil(),
        optedOut: assistantStorage.getOptOut(), now: Date.now(), userTyping: userTypingRef.current,
      });
      if (ok) {
        assistantStorage.markAsked(turn.sessionId);
        onTriggerRef.current({ sessionId: turn.sessionId, messageId: turn.message.id });
      }
    }, DWELL_MS);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageId, isStreaming]);
}
